import axiosInstance from "./AxiosInstance";

/**
 * Get patient cured diseases
 * @param {string|number} patientId - The patient ID
 * @returns {Promise} API response with cured diseases list
 */
export function getPatientCuredDiseases(patientId) {
  return axiosInstance.post("/admin/getPatientCuredDiseases", {
    patient_id: patientId,
  });
}

/**
 * Update patient cured diseases
 * @param {string|number} patientId - The patient ID
 * @param {Array} diseaseIds - Array of disease IDs to mark as cured
 * @returns {Promise} API response from update
 */
export function updatePatientCuredDiseases(patientId, diseaseIds = []) {
  return axiosInstance.post("/admin/updatePatientCuredDiseases", {
    patient_id: patientId,
    diseases_ids: diseaseIds.join(","), // Convert array to comma-separated string
  });
}

/**
 * Format cured diseases response data
 * @param {Array|Object} responseData - The response data from API
 * @returns {Array} Formatted array of disease IDs
 */
export function formatCuredDiseases(responseData) {
  if (!responseData) return [];

  // If response is already an array of IDs
  if (Array.isArray(responseData)) {
    return responseData.map((item) => {
      // Handle both string IDs and objects with disease_id property
      if (typeof item === "string" || typeof item === "number") {
        return String(item);
      }
      return String(item.disease_id || item._id || item.id);
    });
  }

  // If response is an object
  if (typeof responseData === "object") {
    // Check if it has a data property with array of IDs
    if (Array.isArray(responseData.data)) {
      return responseData.data.map((item) => {
        if (typeof item === "string" || typeof item === "number") {
          return String(item);
        }
        return String(item.disease_id || item._id || item.id);
      });
    }

    // If it's a single object, try to extract disease_id
    if (responseData.disease_id) {
      return [String(responseData.disease_id)];
    }
  }

  return [];
}
